import { RewardCategory } from 'hooks/use-feature-loyalty-reward-list-categories-only';

import { BannerTier } from './types';

export const PROGRESS_BAR_TOTAL_WIDTH = 90;

// Removes all characters that are not numbers
export const sanitizeStringToNumber = (value: string): number => {
  if (!value) {
    return 0;
  }
  return Number(value.replace(/[^0-9]/g, ''));
};

export const getProgressBarValue = (userPoints: number, tiers: BannerTier[]): number => {
  if (userPoints === 0) {
    return 0;
  }

  const lastTierIndex = tiers.length - 1;
  if (userPoints >= sanitizeStringToNumber(tiers[lastTierIndex].value)) {
    return 100;
  }

  // Distance between Tiers (in %)
  // Progress bar is 90% of the total width, remaining 10% is fake extension from last tier to infinity
  // Dividing by tiers length - 1, because the first tier is at the very left and the progress bar starts there
  const tierWidth = PROGRESS_BAR_TOTAL_WIDTH / (tiers.length - 1);

  for (let currentTierIndex = 0; currentTierIndex < tiers.length; currentTierIndex++) {
    const currentTier = tiers[currentTierIndex];
    const currentTierPoints = sanitizeStringToNumber(currentTier.value);

    // Exact match with a tier
    if (userPoints === currentTierPoints) {
      return tierWidth * currentTierIndex;
    }

    // UserPoints are between the current tier and the next one
    const nextTierIndex = currentTierIndex < lastTierIndex ? currentTierIndex + 1 : lastTierIndex;
    const nextTier = tiers[nextTierIndex];
    const nextTierPoints = sanitizeStringToNumber(nextTier.value);

    if (userPoints > currentTierPoints && userPoints < nextTierPoints) {
      const pointDiff = userPoints - currentTierPoints;
      const diffBetweenTiers = nextTierPoints - currentTierPoints;

      // Calculates the percentage between one tier and another
      const aux = pointDiff / diffBetweenTiers;
      return (currentTierIndex + aux) * tierWidth;
    }
  }

  return 0;
};

export const mapCategoriesToTiers = (categories: RewardCategory[]) => {
  if (!categories || categories.length === 0) {
    return [];
  }
  return categories.map((category: RewardCategory, index: number) => ({
    id: category?._id || index.toString(),
    value: category?.label?.en || '0',
  }));
};
